import BaseService from './BaseService';

export function apiErrorMessage(error, fallback) {
  const data = error && error.response && error.response.data;
  if (typeof data === 'string' && data.trim()) return data;
  if (data && data.mensagem) return data.mensagem;
  if (data && data.mensagemDetalhada) return data.mensagemDetalhada;
  if (data && data.message) return data.message;
  if (data && data.error) return data.error;
  return fallback;
}

export function uploadKmzMatriz(nsirId, file, onUploadProgress) {
  const formData = new FormData();
  formData.append('arquivo', file);
  return BaseService.postMultipart({
    url: `nsirs/${nsirId}/kmz/matriz`,
    data: formData,
    onUploadProgress,
  });
}

export function fetchKmzSugestao(nsirId, nsirKmzId, params) {
  const search = new URLSearchParams();
  search.set('nsirKmzId', nsirKmzId);
  if (params && params.dispositivosFim) search.set('dispositivosFim', params.dispositivosFim);
  if (params && params.atravessarCategorias) search.set('atravessarCategorias', params.atravessarCategorias);
  return BaseService.get({
    url: `nsirs/${nsirId}/kmz/matriz/sugestao?${search.toString()}`,
  });
}

export function uploadKmzRota(nsirId, nsirKmzId, file, onUploadProgress) {
  const formData = new FormData();
  formData.append('arquivo', file);
  return BaseService.postMultipart({
    url: `nsirs/${nsirId}/kmz/matriz/${nsirKmzId}/rota`,
    data: formData,
    onUploadProgress,
  });
}

export function calcularKmKmz(nsirId, body) {
  return BaseService.post({
    url: `nsirs/${nsirId}/kmz/matriz/calcular-km`,
    data: body,
  });
}

export function confirmarKmzMatriz(nsirId, body) {
  return BaseService.post({
    url: `nsirs/${nsirId}/kmz/matriz/confirmar`,
    data: body,
  });
}

export function listarKmzNsir(nsirId, tipo) {
  const busca = tipo ? `?tipo=${encodeURIComponent(tipo)}` : '';
  return BaseService.get({
    url: `nsirs/${nsirId}/kmz${busca}`,
  });
}

const TIPOS_LISTA_KMZ = ['CRU', 'INSPECAO', 'COMPLETO'];

export async function listarKmzVisiveis(nsirId) {
  const respostas = await Promise.all(
    [null, ...TIPOS_LISTA_KMZ].map((tipo) =>
      listarKmzNsir(nsirId, tipo)
        .then((response) => response && response.data)
        .catch(() => null)
    )
  );
  const arquivos = [];
  respostas.forEach((data) => {
    const lista = Array.isArray(data && data.arquivos) ? data.arquivos : [];
    lista.forEach((entry) => {
      if (!entry || !entry.url || !entry.tipo) return;
      const tipo = String(entry.tipo).trim().toUpperCase();
      if (arquivos.some((item) => String(item.tipo).toUpperCase() === tipo)) return;
      arquivos.push({ ...entry, tipo });
    });
  });
  return { arquivos };
}

const NSIR_KMZ_ID_LEGADO = 'legado';

function idSessaoKmz(data) {
  if (!data || data.nsirKmzId == null) return null;
  const id = String(data.nsirKmzId).trim();
  if (!id || id.toLowerCase() === NSIR_KMZ_ID_LEGADO) return null;
  return id;
}

function idComRecorteConfirmado(data) {
  const id = idSessaoKmz(data);
  if (!id) return null;
  const lista = Array.isArray(data.arquivos) ? data.arquivos : [];
  const temInspecao = lista.some(
    (entry) => entry && entry.url && String(entry.tipo || '').trim().toUpperCase() === 'INSPECAO'
  );
  return temInspecao ? id : null;
}

function jaTemSessaoKmz(error) {
  const msg = apiErrorMessage(error, '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
  return msg.includes('sessao de geracao') || (msg.includes('sessao') && msg.includes('completo'));
}

export function gerarKmzCompletoMatriz(nsirId, nsirKmzId) {
  return BaseService.post({
    url: `nsirs/${nsirId}/kmz/matriz/${nsirKmzId}/completo`,
    data: {},
  });
}

export function gerarKmzCompletoLegado(nsirId) {
  return BaseService.post({
    url: `nsirs/${nsirId}/kmz/legado/completo`,
    data: {},
  });
}

export async function gerarKmzCompletoDaNsir(nsirId) {
  const consulta = await listarKmzNsir(nsirId, 'INSPECAO');
  const nsirKmzId = idComRecorteConfirmado(consulta && consulta.data);
  if (nsirKmzId) return gerarKmzCompletoMatriz(nsirId, nsirKmzId);
  try {
    return await gerarKmzCompletoLegado(nsirId);
  } catch (error) {
    if (!jaTemSessaoKmz(error)) throw error;
    const deNovo = await listarKmzNsir(nsirId, 'INSPECAO');
    const id = idSessaoKmz(deNovo && deNovo.data);
    if (!id) throw error;
    return gerarKmzCompletoMatriz(nsirId, id);
  }
}

export function excluirKmzNsir(nsirId) {
  return BaseService.delete({
    url: `nsirs/${nsirId}/kmz`,
  });
}
